export enum QUERY_KEYS {
  addOfferToGroup = 'add-offer-to-group',
  addOffersToGroup = 'add-offers-to-group',
  createGroup = 'create-group',
  deleteGroup = 'delete-group',
  editGroup = 'edit-group',
  moveOfferToGroup = 'move-offer-to-group',
  removeOfferFromGroup = 'remove-offer-from-group',
}
